module.exports = __webpack_public_path__ + "static/img/product-1.7edc2549.png";